import { advanceGuide } from './guides/advance';
import { apGuide } from './guides/ap';
import { arGuide } from './guides/ar';
import { assetCategoriesGuide } from './guides/asset-categories';
import { cfforecastGuide } from './guides/cfforecast';
import { cipGuide } from './guides/cip';
import { coaGuide } from './guides/coa';
import { docIngestGuide } from './guides/doc-ingest';
import { empbenGuide } from './guides/empben';
import { fixedassetGuide } from './guides/fixedasset';
import { glschedGuide } from './guides/glsched';
import { journalGuide } from './guides/journal';
import { leaseGuide } from './guides/lease';
import { ledgerGuide } from './guides/ledger';
import { lvaGuide } from './guides/lva';
import { masterGuide } from './guides/master';
import { opcontractGuide } from './guides/opcontract';
import { payreqGuide } from './guides/payreq';
import { pettycashGuide } from './guides/pettycash';
import { prepaidGuide } from './guides/prepaid';
import { proptaxGuide } from './guides/proptax';
import { reclassGuide } from './guides/reclass';
import { reconGuide } from './guides/recon';
import { reportsGuide } from './guides/reports';
import { settingsAccountMappingGuide } from './guides/settings-account-mapping';
import { settingsApprovalMatrixGuide } from './guides/settings-approval-matrix';
import { settingsAuditGuide } from './guides/settings-audit';
import { settingsCoaGuide } from './guides/settings-coa';
import { settingsRolesGuide } from './guides/settings-roles';
import { settingsUsersGuide } from './guides/settings-users';
import { suppliersGuide } from './guides/suppliers';
import { vatGuide } from './guides/vat';
import { whtGuide } from './guides/wht';

import type { HelpGuide } from './types';

export type { HelpBlock, HelpGuide, HelpSection } from './types';

// Registry of in-app help guides, keyed by the value passed to <HelpButton guide="…" />.
// Adding a future menu's guide = create ./guides/<page>.ts + one line here.
export const HELP_GUIDES: Record<string, HelpGuide> = {
  journal: journalGuide,
  fixedasset: fixedassetGuide,
  lva: lvaGuide,
  prepaid: prepaidGuide,
  lease: leaseGuide,
  glsched: glschedGuide,
  cip: cipGuide,
  empben: empbenGuide,
  opcontract: opcontractGuide,
  ar: arGuide,
  ap: apGuide,
  suppliers: suppliersGuide,
  pettycash: pettycashGuide,
  advance: advanceGuide,
  payreq: payreqGuide,
  reports: reportsGuide,
  vat: vatGuide,
  wht: whtGuide,
  recon: reconGuide,
  reclass: reclassGuide,
  cfforecast: cfforecastGuide,
  proptax: proptaxGuide,
  coa: coaGuide,
  ledger: ledgerGuide,
  master: masterGuide,
  'doc-ingest': docIngestGuide,
  'asset-categories': assetCategoriesGuide,
  'settings-coa': settingsCoaGuide,
  'settings-account-mapping': settingsAccountMappingGuide,
  'settings-roles': settingsRolesGuide,
  'settings-users': settingsUsersGuide,
  'settings-approval-matrix': settingsApprovalMatrixGuide,
  'settings-audit': settingsAuditGuide,
};

export function getGuide(key: string): HelpGuide | undefined {
  return HELP_GUIDES[key];
}
